import { render, staticRenderFns } from "./AddSectionPage.vue?vue&type=template&id=2f862af4&"
import script from "./AddSectionPage.vue?vue&type=script&lang=js&"
export * from "./AddSectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports